import React, { useEffect, useState } from 'react';
import { SearchIcon, MessageSquareIcon, MusicIcon, UserIcon, UsersIcon, CalendarIcon } from 'lucide-react';
export const HowItWorksSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedPath, setSelectedPath] = useState('teacher'); // Default to teacher path
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('how-it-works');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const studentSteps = [{
    icon: <SearchIcon className="h-8 w-8 text-deep-pink" data-id="element-1546" />,
    title: 'Browse Teachers',
    description: 'Discover teachers by instrument, city, zip code, or reviews.'
  }, {
    icon: <MessageSquareIcon className="h-8 w-8 text-deep-pink" data-id="element-1547" />,
    title: 'Connect',
    description: 'Chat with teachers and ask questions before you book.'
  }, {
    icon: <MusicIcon className="h-8 w-8 text-deep-pink" data-id="element-1548" />,
    title: 'Start Learning',
    description: 'Choose your teacher and begin lessons on your schedule.'
  }];
  const teacherSteps = [{
    icon: <UserIcon className="h-8 w-8 text-blue-600" data-id="element-1549" />,
    title: 'Create a Profile',
    description: 'Create a professional teaching profile with your experience, instruments, availability, and teaching details.'
  }, {
    icon: <UsersIcon className="h-8 w-8 text-blue-600" data-id="element-1550" />,
    title: 'Prepare your profile',
    description: 'Prepare your profile with teaching details, availability, and preferences, ready for future student discovery.'
  }, {
    icon: <CalendarIcon className="h-8 w-8 text-blue-600" data-id="element-1551" />,
    title: 'Start Teaching',
    description: 'Manage lessons and schedules, track progress, and run your teaching studio from one dashboard.'
  }];
  // Select the appropriate steps based on the selected path
  const steps = selectedPath === 'student' ? studentSteps : teacherSteps;
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-1552">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1553">
        <div className="text-center mb-10" data-id="element-1554">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-1555">
            How MaestroConnect Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-1556">
            {selectedPath === 'student' ? 'MaestroConnect connects music teachers and students through modern tools for scheduling, communication, learning, and studio management.' : 'MaestroConnect gives music teachers professional tools to manage lessons, students, scheduling, and studio growth — while helping students discover local and online music teachers.'}
          </p>
          {/* Toggle buttons */}
          <div className="inline-flex bg-gray-100 rounded-lg p-1 mb-8" data-id="element-1557">
            <button onClick={() => setSelectedPath('teacher')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${selectedPath === 'teacher' ? 'bg-navy-800 text-white' : 'text-gray-700 hover:bg-gray-200'}`} data-id="element-1558">
              I'm a Teacher
            </button>
            <button onClick={() => setSelectedPath('student')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${selectedPath === 'student' ? 'bg-navy-800 text-white' : 'text-gray-700 hover:bg-gray-200'}`} data-id="element-1559">
              I'm a Student
            </button>
          </div>
        </div>
        {selectedPath === 'student' ? <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-1560">
            <div className="bg-gray-50 rounded-xl p-12 shadow-sm border border-gray-100 text-center max-w-3xl mx-auto" data-id="element-1561">
              <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1562">
                Student Experience
              </h3>
              <p className="text-lg text-gray-600" data-id="element-1563">
                Discover music teachers, manage lessons, communicate with
                instructors, and track your learning progress — all in one
                modern platform.
              </p>
            </div>
          </div> : <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1564">
            {steps.map((step, index) => <div key={`${selectedPath}-${index}`} className={`bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100 transition-all duration-700 delay-${index * 200} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-1565">
                <div className="bg-lavender/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-1566">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1567">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-1568">{step.description}</p>
              </div>)}
          </div>}
      </div>
    </section>;
};